// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("moment")
require("bootstrap/dist/js/bootstrap")
require("jgrowl")
require('spotlight_search')
require("bootstrap-daterangepicker")
require('canvas')
require('jsbarcode')

import jQuery from 'jquery';
window.$ = jQuery
window.jQuery = jQuery
import 'select2';                       // globally assign select2 fn to $ element
import './orders.coffee'
import './users.coffee'
import './scaffolds.coffee'
import './addresses.coffee'
import './form-validation.coffee'
import '@fortawesome/fontawesome-free/js/all.js'
import './cocoon.js'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
